import { ConfirmationformComponent } from './../../user/confirmationform/confirmationform.component';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {
  HttpClient,
  HttpParams,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { ApiHelper } from './../../_helpers/api.helper';
import { CommonHelper } from './../../_helpers/common.helper';
import { ConstantHelper } from './../../_helpers/constant.helper';
import { AppConfig } from './../../../app/app.config';
import { SweetAlertHelper } from 'src/app/_helpers/sweet.alert.helper';
import { Message } from 'src/app/_locale/message';

@Component({
  selector: 'app-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.scss'],
})
export class DocumentListComponent implements OnInit {
  loggedInUserId: string;
  resultJsonObj: any = {};
  comapnyName: string = ConstantHelper.COMPANY_NAME;
  selectedDocId: string;
  selectedDocUrl: string;
  selectedDocName: string;
  showPdfModal = false;
  childRoute: string;

  docDeactivateSuccess = false;
  docActivateSuccess = false;
  docErrorFlashMsg = false;

  docUploadSuccess = false;

  documentsLength = false;
  documentsList: any;

  ahsPdfUrl: SafeResourceUrl = '';
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });
  httpOptions = {
    headers: this.httpHeaders,
  };
  showLoader = false;
  message = Message;
  dtOptions: DataTables.Settings = {};
  isPrimary = sessionStorage.getItem('isPrimary');
  constructor(
    public commonHelper: CommonHelper,
    private appConfig: AppConfig,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public sweetAlertHelper: SweetAlertHelper,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    // console.log(activatedRoute.snapshot.url); // array of states
    localStorage.setItem('childRoute', activatedRoute.snapshot.url[0].path);
    this.childRoute = activatedRoute.snapshot.url[0].path;
  }

  ngOnInit() {
    this.loggedInUserId =
      this.activatedRoute.snapshot.paramMap.get('loggedInUserId');
    this.findDocumentsList();
    this.dtOptions = {
      order: [[0, 'desc']], // This will sort the first column (index 0) in descending order (use 'asc' for ascending).
    };
  }

  findDocumentsList() {
    const finalData = {
      loggedInUserId: this.loggedInUserId,
      company_slug: ConstantHelper.COMPANY_SLUG,
    };
    this.showLoader = true;
    this.http
      .post(
        this.appConfig.getLambdaUrl02() +
          ApiHelper.name_getAdminDocumentsListApi,
        finalData,
        this.httpOptions
      )
      .subscribe(
        (apiResponse) => {
          this.showLoader = false;
          this.resultJsonObj = apiResponse;
          if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
            this.documentsLength = true;
            this.documentsList =
              this.resultJsonObj.commandResult.data.documentList;
            console.log(this.documentsList);
          } else {
            this.documentsLength = false;
          }
          // console.log(this.documentsLength);
        },
        (err) => {
          this.showLoader = false;
          // console.log(err);
        }
      );
  }

  closePdfModal() {
    this.showPdfModal = false;
  }

  loadDocunent(docId, docUrl, docName) {
    this.selectedDocId = docId;
    this.selectedDocUrl = docUrl;
    this.selectedDocName = docName;
    this.showPdfModal = true;
    this.ahsPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.selectedDocUrl
    );
  }

  async disableDoc(DocID) {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: By disabling this document, you are removing it from active document groups."
    //   )
    // )
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.documenmnetlistComp.disableDoc
    );
    if (alertStatus) {
      const finalData = {
        doc_id: DocID,
        loggedInUserId: this.loggedInUserId,
        company_slug: ConstantHelper.COMPANY_SLUG,
      };

      this.http
        .post(
          this.appConfig.getLambdaUrl02() + ApiHelper.name_deactivateDocApi,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse) => {
            this.resultJsonObj = apiResponse;
            if (this.resultJsonObj.commandResult.status == 1) {
              if (
                this.resultJsonObj.commandResult.data.documentList.length > 0
              ) {
                this.documentsLength = true;
                this.documentsList =
                  this.resultJsonObj.commandResult.data.documentList;
                // console.log(this.documentsList);
              } else {
                this.documentsLength = false;
              }
              this.docDeactivateSuccess = true;
              setTimeout(() => {
                this.docDeactivateSuccess = false;
              }, 2000);
              window.location.reload();
            } else {
              this.docErrorFlashMsg = true;
              setTimeout(() => {
                this.docErrorFlashMsg = false;
              }, 3000);
            }
            window.location.reload();
          },
          (err) => {
            // console.log(err);
          }
        );
      // this.showLoader = true;
      // window.location.reload();
      // this.showLoader = false;
    }
  }

  async enableDoc(DocID) {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM:
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.documenmnetlistComp.enableDoc
    );
    if (alertStatus) {
      //   )
      // )
      const finalData = {
        doc_id: DocID,
        loggedInUserId: this.loggedInUserId,
        company_slug: ConstantHelper.COMPANY_SLUG,
      };

      this.showLoader = true;
      this.http
        .post(
          this.appConfig.getLambdaUrl02() + ApiHelper.name_activateDocApi,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse) => {
            this.showLoader = false;
            this.resultJsonObj = apiResponse;
            if (this.resultJsonObj.commandResult.status == 1) {
              if (
                this.resultJsonObj.commandResult.data.documentList.length > 0
              ) {
                this.documentsLength = true;
                this.documentsList =
                  this.resultJsonObj.commandResult.data.documentList;
                // console.log(this.documentsList);
              } else {
                this.documentsLength = false;
              }
              this.docActivateSuccess = true;
              setTimeout(() => {
                this.docActivateSuccess = false;
              }, 2000);
              window.location.reload();
            } else {
              this.docErrorFlashMsg = true;
              setTimeout(() => {
                this.docErrorFlashMsg = false;
              }, 3000);
            }
          },
          (err) => {
            // console.log(err);
          }
        );
      // this.showLoader = true;
      // window.location.reload();
      // this.showLoader = false;
    }
  }

  async changeShowOnConfirmationStatus(DocID, statusId) {
    const confirmationMag = '';
    let confMsg = '';
    if (statusId == 1) {
      // confirmationMag =
      //   "PLEASE CONFIRM: Are you certain you want to enable the signature requirement?";
      confMsg = this.message.confirmMessages.documenmnetlistComp.changesShow;
    } else {
      // confirmationMag =
      //   "PLEASE CONFIRM: Are you certain you want to disable the signature requirement?";
      confMsg = this.message.confirmMessages.documenmnetlistComp.changesShow1;
    }

    const confirmStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      confMsg
    );
    if (confirmStatus) {
      this.showLoader = true;
      const finalData = {
        doc_id: DocID,
        status_id: statusId,
        loggedInUserId: this.loggedInUserId,
        company_slug: ConstantHelper.COMPANY_SLUG,
      };

      this.http
        .post(
          this.appConfig.getLambdaUrl02() +
            ApiHelper.name_changeShowOnConfirmationStatusApi,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse) => {
            this.showLoader = false;
            window.location.reload();

            this.resultJsonObj = apiResponse;
            if (this.resultJsonObj.commandResult.status == 1) {
              if (
                this.resultJsonObj.commandResult.data.documentList.length > 0
              ) {
                this.documentsLength = true;
                this.documentsList =
                  this.resultJsonObj.commandResult.data.documentList;
                // console.log(this.documentsList);
              } else {
                this.documentsLength = false;
              }
              this.docActivateSuccess = true;
              setTimeout(() => {
                this.docActivateSuccess = false;
              }, 2000);
            } else {
              this.docErrorFlashMsg = true;
              setTimeout(() => {
                this.docErrorFlashMsg = false;
              }, 3000);
            }
          },
          (err) => {
            // console.log(err);
          }
        );
    }
  }

  async openAddDocPage() {

    // if (confirm('Click to confirm you want to add a new document.'))
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.documenmnetlistComp.openAddDocPage
    );
    if (alertStatus) {
      this.router.navigate([
        '/' + this.childRoute + '/add-admin-doc/' + this.loggedInUserId,
      ]);
    }
  }

  async openModifyDocPage(doc_id, doc_name, doc_description, ShowConfirmation) {
    // alert(doc_description)

    // tslint:disable-next-line: max-line-length
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: Are you sure you want to upload this file as a replacement? Document you are replacing can be restored from the logs should you change your mind."
    //   )
    // )
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.documenmnetlistComp.openModifyDoc
    );
    if (alertStatus) {
      localStorage.setItem('doc_description', doc_description);
      localStorage.setItem('ShowConfirmation_status', ShowConfirmation);
      this.router.navigate([
        '/' +
          this.childRoute +
          '/modify-admin-doc/' +
          this.loggedInUserId +
          '/' +
          doc_id +
          '/' +
          doc_name,
      ]);
    }
  }

  async viewDocGroups() {
    // if (
    //   confirm(
    //     "PLEASE CONFIRM: By clicking OK, you are now able to rearrange current documents into subgroups."
    //   )
    // )
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.documenmnetlistComp.viewDocGroups
    );
    if (alertStatus) {
      this.router.navigate([
        '/' + this.childRoute + '/add-doc-group/' + this.loggedInUserId,
      ]);
    }
  }

  goToLogs() {
    this.router.navigate([
      '/' + this.childRoute + '/activity-logs/' + this.loggedInUserId,
    ]);
  }

   async disableUploadDocument(DocID) {
    let confMsg = '';
    confMsg = this.message.confirmMessages.documenmnetlistComp.disableUploadDocument;
    const confirmStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      confMsg
    );
  
    if (confirmStatus) { 
      const finalData = {
        doc_id: DocID,
        loggedInUserId: this.loggedInUserId,
        company_slug: ConstantHelper.COMPANY_SLUG,
      };
      this.showLoader = true;
      this.http
        .post(
          this.appConfig.getLambdaUrl05() + ApiHelper.changeUploadDocumentStatus,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse) => {
            this.showLoader = false;
            this.resultJsonObj = apiResponse;
            if (this.resultJsonObj.commandResult.status == 1) {
              if (this.resultJsonObj.commandResult.data.documentList.length > 0) {
                this.documentsLength = true;
                this.documentsList = this.resultJsonObj.commandResult.data.documentList;
              } else {
                this.documentsLength = false;
              }
              this.docUploadSuccess = true;
              setTimeout(() => {
                this.docUploadSuccess = false;
              }, 2000);
              // Reload the page after successful operation
              window.location.reload();
            } else {
              this.docErrorFlashMsg = true;
              setTimeout(() => {
                this.docErrorFlashMsg = false;
              }, 3000);
            }
          },
          (err) => {
            this.showLoader = false;
            // console.log(err);
          }
        );
    }
  }
 

  async enableElecFill(DocID) {
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.documenmnetlistComp.elctronicallyFill
    );
    if (alertStatus) {
      const finalData = {
        doc_id: DocID
      };
      this.showLoader = true;
      this.http
        .post(
          this.appConfig.getLambdaUrl06() + ApiHelper.enableElectronicallyFill,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse) => {
            this.showLoader = false;
            this.resultJsonObj = apiResponse;
            if (this.resultJsonObj.commandResult.status == 1) {
              window.location.reload();
            } else {
              this.docErrorFlashMsg = true; 
              setTimeout(() => {
                this.docErrorFlashMsg = false;
              }, 3000);
            }
          },
          (err) => {
            this.showLoader = false;
          }
        );
      
    }
}
  async disableElecFill(DocID) {
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.documenmnetlistComp.disableelctrFill
    );
    if (alertStatus) {
      const finalData = {
        doc_id: DocID
      };

      this.http
        .post(
          this.appConfig.getLambdaUrl06() + ApiHelper.disableElectronicallyFill,
          finalData,
          this.httpOptions
        )
        .subscribe(
          (apiResponse) => {
            this.resultJsonObj = apiResponse;
            if (this.resultJsonObj.commandResult.status == 1) {
              window.location.reload();
              }else {
              this.docErrorFlashMsg = true;
              setTimeout(() => {
                this.docErrorFlashMsg = false;
              }, 3000);
            }
            window.location.reload();
          },
          (err) => {
            // console.log(err);
          }
        );
    }
  }

  async goToDocuments() {
    // if (
    //   confirm("PLEASE CONFIRM: Are you sure, you want to go to document list?")
    // )
    const alertStatus = await this.sweetAlertHelper.confirmPopUp(
      this.message.confirmTitle,
      this.message.confirmMessages.addDocComp.goToDocuments
    );
    if (alertStatus) {
      this.router.navigate([
        '/' + this.childRoute + '/documents/' + this.loggedInUserId,
      ]);
    }
  }

}
